import { useEffect, useState, useRef } from "react";
import "./TestHeader.css";

function formatTime(sec) {
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${m}:${s.toString().padStart(2, "0")}`;
}

const TestHeader = ({
    jobTitle,
    candidate,
    duration,
    onSubmit,
    showTimer = true,
    showSubmit = true,
}) => {
    const [timeLeft, setTimeLeft] = useState(duration);
    const endTimeRef = useRef(null);

    useEffect(() => {
        if (!showTimer) return;

        if (!endTimeRef.current) {
            endTimeRef.current = Date.now() + duration * 1000;
        }

        const timer = setInterval(() => {
            const diff = Math.max(
                0,
                Math.floor((endTimeRef.current - Date.now()) / 1000)
            );
            setTimeLeft(diff);
        }, 1000);

        return () => clearInterval(timer);
    }, [showTimer, duration]);

    return (
        <div className="test-header">
            <div className="header-left">
                <img src="/logo.png" alt="Company logo" className="company-logo" />
                <div>
                    <h2>Application test for {jobTitle}</h2>
                    <p>
                        Candidate {candidate.name} – {candidate.email}
                    </p>
                </div>
            </div>

            <div className="header-right">
                {showTimer && <div className="timer">{formatTime(timeLeft)}</div>}
                {showSubmit && (
                    <button className="submit-btn" onClick={onSubmit}>
                        Submit
                    </button>
                )}
            </div>
        </div>
    );
};

export default TestHeader;
